export function* generateAliases<T extends string>(
  locales: readonly T[]
): Generator<[string, T]> {
  const set = new Set<{
    locale: T;
    parts: string[];
  }>(locales.map((locale) => ({ locale, parts: locale.split('-') })));

  const columns: [string, T][] = [];
  let rindex = 0;
  while (set.size) {
    for (const entry of set) {
      const { locale, parts } = entry;
      const endIndex = parts.length - rindex;
      if (endIndex <= 0) {
        set.delete(entry);
      }
      const spec = parts.slice(0, endIndex).join('-');
      if (spec) {
        yield [spec, locale];
      }
      if (endIndex > 1) {
        columns.push([parts[endIndex - 1], locale]);
      }
    }
    rindex += 1;
  }

  for (const [spec, locale] of columns) {
    yield [spec, locale];
  }
}
